import { inject, Injectable } from '@angular/core';

import { Browser } from '@capacitor/browser';
import { AlertOptions } from '@ionic/angular';
import { select, Store } from '@ngrx/store';

import { cloneDeep, isNull, omit } from 'lodash-es';

import { MiddlewareError } from '../../classes/middleware-error';
import * as fromDataPortalSelectors from '../../store/selectors/data-portal.selectors';

@Injectable({
  providedIn: 'root'
})
export class MiddlewareMessageService {
  static readonly defaultDataPortalName = 'Data Portal';
  static readonly defaultDataPortalUrl = 'their website';

  private store = inject(Store);
  dataPortalName = MiddlewareMessageService.defaultDataPortalName;
  dataPortalUrl = MiddlewareMessageService.defaultDataPortalUrl;
  constructor() {
    this.store.pipe(select(fromDataPortalSelectors.selectName)).subscribe((name) => {
      this.dataPortalName = name ? name : MiddlewareMessageService.defaultDataPortalName;
    });
    this.store.pipe(select(fromDataPortalSelectors.selectUrl)).subscribe((url) => {
      this.dataPortalUrl = url ? url : MiddlewareMessageService.defaultDataPortalUrl;
    });
  }

  processStatus(statusCode: string | null, status: string | null) {
    const message = status ?? 'There was a issue with your last request. Please try again later.';
    let isInvalidKey = false;
    let hasError = false;
    let error = new MiddlewareError(message);
    if (!isNull(status)) {
      if (status.match(/\[code13]/) || statusCode?.includes('NM')) {
        hasError = true;
        error = new MiddlewareError(
          'No property records match your search.',
          omit(cloneDeep(MiddlewareError.defaultAlertOptions), 'header')
        );
      } else if (
        status.match(/\[code13_IK]/) ||
        ['Invalid Access Key', 'Invalid accessKey', 'Invalid Key'].indexOf(message) !== -1
      ) {
        hasError = true;
        isInvalidKey = true;
        const alertOptions: AlertOptions = {
          buttons: [
            {
              role: 'cancel',
              text: 'Ok'
            }
          ],
          header: 'Log-In Issue'
        };

        try {
          const url = new URL(this.dataPortalUrl);
          alertOptions.buttons?.push({
            handler: async () => {
              await Browser.open({
                url: url.toString(),
                windowName: '_blank'
              });
              return false;
            },
            text: this.dataPortalName
          });
        } catch {
          /* empty */
        }

        error = new MiddlewareError(
          `Refresh your ${this.dataPortalName} credentials. In the app, go to More -> Login Credentials and update.`,
          alertOptions
        );
      } else if (!statusCode?.includes('OK') && !statusCode?.includes('MM')) {
        hasError = true;
      }
    }

    return { error, hasError, isInvalidKey };
  }
}
